import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/historial',
    name: 'Historial',
    component: () => import(/* webpackChunkName: "about" */ '../views/Travels.vue')
  },
  {
    path: '/viaje/:id',
    name: 'Viaje',
    component: () => import(/* webpackChunkName: "about" */ '../views/Travel.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
